import { useState, useContext } from 'react';
import UIButton from 'UIComponents/button/UIButton';
import UIIcon from 'UIComponents/icon/UIIcon';
import FormattedMessage from 'I18n/components/FormattedMessage';
import Trackables from 'automation-ui-usage-tracking/Trackables';
import { useTrackEvent } from 'automation-ui-usage-tracking/usageTrackingHooks';
import { sendMessageToParent } from 'ui-addon-automation-embed/embedUtils';
import PostMessageTypes from 'ui-addon-automation-embed/PostMessageTypes';
import ObjectTypePropertiesContext from 'automation-ui-references/object-type-properties/ObjectTypePropertiesContext';
import { PropertyManagementModalIFrame } from 'property-management-iframe';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const DataPanelCreatePropertyButton = ({
  objectTypeId,
  onPropertyCreated
}) => {
  const {
    embedId
  } = useContext(ObjectTypePropertiesContext);
  const [showCreatePropertyModal, setShowCreatePropertyModal] = useState(false);
  const trackEvent = useTrackEvent();
  const handleHideModal = () => {
    setShowCreatePropertyModal(false);
    if (embedId) {
      sendMessageToParent({
        type: PostMessageTypes.UNDO_FULL_SCREEN_SIDE_PANEL,
        embedId
      });
    }
  };
  const handleShowModal = () => {
    trackEvent(Trackables.CLICK_CREATE_NEW_PROPERTY_LINK, {
      objectType: objectTypeId,
      actionType: 'Data panel'
    });
    setShowCreatePropertyModal(true);
    if (embedId) {
      sendMessageToParent({
        type: PostMessageTypes.FULL_SCREEN_SIDE_PANEL,
        embedId
      });
    }
  };
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(View, {
      blockSize: "1400",
      padding: "400",
      children: /*#__PURE__*/_jsxs(UIButton, {
        use: "tertiary",
        block: true,
        onClick: handleShowModal,
        children: [/*#__PURE__*/_jsx(UIIcon, {
          name: "add"
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: "automation-ui-formula-editor.data-passing-panel.ux-revised-mode.create-property-btn"
        })]
      })
    }), showCreatePropertyModal && /*#__PURE__*/_jsx(PropertyManagementModalIFrame, {
      mode: "QUICK_CREATE",
      open: showCreatePropertyModal,
      createParams: {
        initialPropertyConfig: {
          objectTypeId: {
            value: objectTypeId
          }
        }
      },
      onClose: handleHideModal,
      onResult: data => {
        if (onPropertyCreated && !data.cancelled && data.type === 'create' && data.createdPropertyDefinition) {
          onPropertyCreated(data.createdPropertyDefinition.property);
        }
      }
    })]
  });
};
export default DataPanelCreatePropertyButton;